var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import useDrag from "../services/drag.js";
function withDrag(BaseClass, { target = (instance) => instance.$el, ...options } = {}) {
  var _a;
  return _a = class extends BaseClass {
    constructor(el) {
      super(el);
      this.$on("mounted", () => {
        this.$services.register("dragged", useDrag.bind(void 0, target.call(this, this), options));
        this.$services.enable("dragged");
      });
      this.$on("destroyed", () => {
        this.$services.disable("dragged");
        this.$services.unregister("dragged");
      });
    }
  }, __publicField(_a, "config", {
    name: `${BaseClass.config.name}WithDrag`,
    emits: ["dragged"]
  }), _a;
}
export {
  withDrag as default
};
